import cn from "../../lib/classnames";
import DownloadArrow from "../icons/DownloadArrow";
import gradientStyles from "../../styles/Gradient.module.css";
import React from "react";
import styles from "./DownloadButton.module.css";

const strings = {
    download: "Download PDF",
};

type Props = {
    url: string;
    className?: string;
};

export default function DownloadButton(props: Props) {
    return (
        <a
            className={cn(styles.button, gradientStyles.grey, props.className)}
            href={props.url}
            target="_blank"
            rel="noopener noreferrer"
        >
            <DownloadArrow className={styles.arrow} />
            {strings.download}
        </a>
    );
}
